module.exports = __webpack_public_path__ + "static/media/zach-fingerprint-lite.d366c26c.PNG";